import { DWB_LESSONS_BASE_PATH } from 'containers/Product/constants'
import { getProductNameFromUrl } from 'utils/routing/routeHelpers'
import { BACK_LINK_LABEL_BY_PRODUCT } from './constants'

export function getBackLinkLabel({ contentGroupCode, productName } = {}) {
  const resolvedProductName =
    contentGroupCode === 'dwb' ? 'digital-well-being' : productName

  return BACK_LINK_LABEL_BY_PRODUCT[resolvedProductName] ?? 'Lessons'
}

function resolveLessonsLandingPath(productName) {
  return productName ? `/product/${productName}/lessons` : DWB_LESSONS_BASE_PATH
}

/**
 * Creates a back-click handler for UnitV3. Routes to the product lessons
 * landing, preserving query params when present.
 */
export const handleBackClick = ({ location, navigationEvent, productName }) => {
  return function onBackClick() {
    const search = location?.search || ''
    const searchSuffix = search
      ? search.startsWith('?')
        ? search
        : `?${search}`
      : ''
    const destination = resolveLessonsLandingPath(productName)

    navigationEvent(`${destination}${searchSuffix}`)
  }
}

/**
 * Factory for the unit-tab change handler. Mirrors TieredInterventionsUnits
 * so that downstream code can swap the page in without rewiring callers.
 */
export const handleTabChange = ({ location, navigationEvent }) => {
  return function onTabChange(tab) {
    const { search } = location || {}
    const destination = `${tab?.route}?${new URLSearchParams(
      search,
    )?.toString()}`
    navigationEvent(destination)
  }
}

export const getPathForRoute = ({
  routeValue,
  matchUrl,
  queryParamsString,
}) => {
  if (!routeValue || typeof routeValue !== 'string') return ''
  if (routeValue.startsWith('/')) return `${routeValue}${queryParamsString}`
  return `${matchUrl}/${routeValue}${queryParamsString}`
}

export const getTrainingPathForRoute = ({
  routeValue,
  matchUrl,
  productName,
  queryParamsString,
}) => {
  if (!routeValue || typeof routeValue !== 'string') return ''
  const resolvedProductName = productName || getProductNameFromUrl(matchUrl)

  if (routeValue.startsWith('/product/')) {
    return `${routeValue}${queryParamsString}`
  }

  if (routeValue.startsWith('/training/')) {
    if (!resolvedProductName) {
      return `${routeValue}${queryParamsString}`
    }
    return `/product/${resolvedProductName}${routeValue}${queryParamsString}`
  }

  if (routeValue.startsWith('/')) return `${routeValue}${queryParamsString}`

  if (!resolvedProductName) {
    return getPathForRoute({ routeValue, matchUrl, queryParamsString })
  }

  return `/product/${resolvedProductName}/training/${routeValue}${queryParamsString}`
}
